import React, { FormEvent } from 'react'

type PasswordFormProps = {
  onSubmit: (password: string) => boolean
  password: string
  setPassword: (password: string) => void
  error: string
  setError: (error: string) => void
}

const PasswordForm = ({
  onSubmit,
  password,
  setPassword,
  error,
  setError
}: PasswordFormProps) => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!password) {
      setError('La password è richiesta')
      return
    }

    const result = onSubmit(password)
    if (!result) {
      setError('Password errata')
    } else {
      setError('')
    }
  }

  return (
    <div className="relative z-10 flex h-[calc(100vh_-_8rem)] items-center justify-center md:h-[calc(100vh_-_10rem)]">
      <div className="mx-auto flex min-w-[400px] flex-col items-center justify-center gap-6 rounded-xxs bg-white/50 p-5 shadow-3xl backdrop-blur-sm">
        <h1>Contenuto Protetto</h1>
        <form onSubmit={handleSubmit} className="w-full">
          <div className="mb-4 w-full">
            <input
              type="password"
              placeholder="Inserisci password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xxs border border-neutral-50 p-4 outline-none"
            />
          </div>
          <button
            type="submit"
            className="bg-blue-soft cursor-pointer rounded-xxs border-0 px-5 py-3 text-white"
          >
            Invia
          </button>
        </form>
        {error && <p className="mt-3 text-error">{error}</p>}
      </div>
    </div>
  )
}

export default PasswordForm
